// extracted by mini-css-extract-plugin
export default {"CopyElement":"style_CopyElement__Vy3St","CopyElement__caption":"style_CopyElement__caption__zAuRH","CopyElement__title":"style_CopyElement__title__7nGKj"};